class BbdPdpBreadcrumbs extends HTMLElement {
  connectedCallback() {
    try {
      this.#upgradeBackLink();
    } finally {
      this.removeAttribute('data-loading');
    }

    // iOS Safari restores pages from bfcache without re-running JS.
    // Re-remove the loading state if the page is served from cache.
    this.#boundPageShow = this.#onPageShow.bind(this);
    window.addEventListener('pageshow', this.#boundPageShow);
  }

  disconnectedCallback() {
    if (this.#boundPageShow) {
      window.removeEventListener('pageshow', this.#boundPageShow);
    }
  }

  #boundPageShow = null;

  #onPageShow(event) {
    if (event.persisted) {
      this.removeAttribute('data-loading');
    }
  }

  #upgradeBackLink() {
    const shopUrl = this.dataset.shopUrl;

    try {
      const stored = localStorage.getItem('bbd_last_collection');
      if (!stored) return;

      const { url, title } = JSON.parse(stored);
      if (!url || !title) return;

      // Validate same origin
      const shopOrigin = new URL(shopUrl).origin;
      const collectionOrigin = new URL(url).origin;
      if (collectionOrigin !== shopOrigin) return;

      const backLink = this.querySelector('.back-link');
      if (!backLink) return;

      backLink.href = url;

      const titleEl = backLink.querySelector('.bbd-pdp-breadcrumbs__back-text');
      if (titleEl) titleEl.textContent = title;

      localStorage.removeItem('bbd_last_collection');
    } catch {
      // Malformed data — silently ignore
    }
  }
}

customElements.define('bbd-pdp-breadcrumbs', BbdPdpBreadcrumbs);
